import { parseColorToRgba } from './file-kit';

/**
 * 十六进制颜色值转 RGBA 颜色值数组
 *
 * @param sHex - 十六进制颜色值
 * @returns 返回 RGBA 格式的颜色值
 */
export const hexToRgbaArr = (sHex: string) => {
    // 十六进制颜色值的正则表达式
    const reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{4}|[0-9a-fA-f]{6}|[0-9a-fA-f]{8})$/;
    /* 16进制颜色转为RGB格式 */
    let sColor = sHex.toLowerCase();
    let alpha = 1;
    if (sColor && reg.test(sColor)) {
        if (sColor.length === 4 || sColor.length === 5) {
            let sColorNew = '#';
            for (let i = 1; i < sColor.length; i += 1) {
                sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1));
            }
            sColor = sColorNew;
        }
        // 如果有透明度再执行
        if (sColor.length === 9) {
            alpha = Number((parseInt('0x' + sColor.slice(7, 9)) / 255).toFixed(2));
        }
        //  处理六位的颜色值
        const sColorChange: number[] = [];
        for (let i = 1; i < 7; i += 2) {
            sColorChange.push(parseInt('0x' + sColor.slice(i, i + 2)));
        }
        return [...sColorChange, alpha];
    } else {
        return sColor;
    }
};

/**
 * 检查颜色值是否为线性渐变
 *
 * @param color - 颜色值
 * @returns 返回是否为线性渐变
 */
export const checkLinearGradient = function (color: string) {
    return color.indexOf('linear-gradient') !== -1;
};

/**
 * 判断颜色是否为暗色
 * @doc https://cf.meitu.com/confluence/pages/viewpage.action?pageId=531357711
 * @param bgColor - 颜色
 * @returns
 */
export const checkIsDarkColor = (color: string) => {
    try {
        if (!color || color === 'transparent') return false;
        const rgba = parseColorToRgba(color);
        // 计算相对亮度
        const luminance = (0.299 * rgba.r + 0.587 * rgba.g + 0.114 * rgba.b) / 255;
        // 返回是否为暗色
        return luminance < 0.5;
    } catch (_) {
        return false;
    }
};

/**
 * 检查颜色是否为透明色
 *
 * @param color - 颜色值
 * @returns 返回是否为透明色
 */
export const checkIsTransparentColor = (color?: string) => {
    if (!color) {
        return false;
    }

    if (color === 'transparent') {
        return true;
    }

    const rgba = parseColorToRgba(color);
    return rgba.a === 0;
};
